class AccountDrawer extends Drawer {
    constructor() {
        super();
    }

    connectedCallback() {
        // Apre il drawer al click sull'icona
        document.querySelectorAll('#account-icon-bubble').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                this.open();
            });
        });

        // Setup click su tab
        this.querySelectorAll('[data-tab]').forEach((tab) => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                const tabName = tab.getAttribute('data-tab');
                this.showTab(tabName);
            });
        });

        // Mostra di default il login
        this.showTab('drawer-login-form');
    }

    showTab(current) {
        const validTabs = ['drawer-login-form', 'drawer-register-form'];

        // Nasconde tutto
        validTabs.forEach((id) => {
            const section = this.querySelector(`#${id}`);
            section?.classList.add('tw-hidden');
        });

        // Mostra solo il tab selezionato
        const active = this.querySelector(`#${current}`);
        if (active) {
            active.classList.remove('tw-hidden');
        }

        // Aggiorna lo stato visivo dei tab
        this.querySelectorAll('[data-tab]').forEach((tab) => {
            const isActive = tab.getAttribute('data-tab') === current;
            ['tw-underline','tw-decoration-[1px]', 'tw-enjp-s-light', '!tw-text-darkgrey100'].forEach(cls => {
                tab.classList.toggle(cls, !isActive);
            });

        });
    }
}

if (!customElements.get('account-drawer')) {
    customElements.define('account-drawer', AccountDrawer);
}
